export default [
    {
      path: '/admin/return-from-vendors',
      name: 'return-from-vendor',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/return-from-vendor/index.vue')
    },
    {
      path: '/admin/return-from-vendors/create',
      name: 'return-from-vendor-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/return-from-vendor/create.vue')
    },
    {
      path: '/admin/return-from-vendors/:id/edit',
      name: 'return-from-vendor-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/return-from-vendor/edit.vue')
    }
  ]
  